import React, { useState, useEffect, PropsWithChildren } from 'react'

import { generateRandomString } from './helpers'

type Props = {
  speed?: number
}

export const MatrixEffectText = ({
  children,
  speed = 75,
}: PropsWithChildren<Props>) => {
  const [displayedText, setDisplayedText] = useState<string>('')

  useEffect(() => {
    let currentIndex = 0
    const length = (children as string).length
     
    let intervalId: NodeJS.Timeout

    const randomChar = (): string => {
      const random = generateRandomString(25)
      const chars = [...(children as string), ...random]
      return chars[Math.floor(Math.random() * chars.length)]
    }

    const updateText = (): void => {
      const currentText = displayedText.split('')
      currentText[currentIndex] = randomChar()

      setDisplayedText(currentText.join(''))
      currentIndex += 1

      if (currentIndex >= length) {
        clearInterval(intervalId)
      }
    }

    intervalId = setInterval(() => {
      updateText()

      if (currentIndex <= length) {
        setTimeout(() => {
          const currentText = displayedText.split('')
          currentText[currentIndex - 1] = (children as string)[currentIndex - 1]
          setDisplayedText(currentText.join(''))
        }, speed * 0.8)
      }
    }, speed)

    return () => clearInterval(intervalId)
  }, [children, displayedText, speed])

  return <>{displayedText}</>
}
